
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZfCQd165m49OWbEX26SgbL84J9pGBjDf6GPByuXifusMeta } from "/builds/teamtilt/web/tilt-web/pages/index.vue?macro=true";
import { default as termssm3wCiKLSe54mXsF9Hx6SmQ9pu6yxlQdycSUbFzAeKEMeta } from "/builds/teamtilt/web/tilt-web/pages/terms.vue?macro=true";
import { default as cookiesT_guyTAK23Cccin1xjXwACbWVmXNIxKyZSRgJpB25_458Meta } from "/builds/teamtilt/web/tilt-web/pages/cookies.vue?macro=true";
import { default as privacyJefJNk3ibYX0cCIQRhN28AhS2bsFChhO0orl4aCItJwMeta } from "/builds/teamtilt/web/tilt-web/pages/privacy.vue?macro=true";
import { default as _91id_936XsMaq8s7PacOtANeby6ik_45zbIsfy7KE4lijZDqptM4Meta } from "/builds/teamtilt/web/tilt-web/pages/rooms/[id].vue?macro=true";
import { default as _91id_93_45_NfpBHtAb4hS6_f6EF5PyfaenzC_45j1g90M_45Xh8r_XQMeta } from "/builds/teamtilt/web/tilt-web/pages/products/[id].vue?macro=true";
import { default as apply_45tD6Gx_45XsZAqH1IHVzrSb5TllbNrB_rt7yQQy6_XLPkMeta } from "/builds/teamtilt/web/tilt-web/pages/sellers/apply.vue?macro=true";
import { default as indexhX0lGB6epoKyqyUeTI0Rw6_gn8QH0RrKwXHU_hbHJUsMeta } from "/builds/teamtilt/web/tilt-web/pages/sellers/index.vue?macro=true";
import { default as acceptable_45useE9L8hotiqtbSoEEQn515k2qyhHzJ8tmH_45_BcHGqmg1MMeta } from "/builds/teamtilt/web/tilt-web/pages/acceptable-use.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexZfCQd165m49OWbEX26SgbL84J9pGBjDf6GPByuXifusMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termssm3wCiKLSe54mXsF9Hx6SmQ9pu6yxlQdycSUbFzAeKEMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/terms.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    meta: cookiesT_guyTAK23Cccin1xjXwACbWVmXNIxKyZSRgJpB25_458Meta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyJefJNk3ibYX0cCIQRhN28AhS2bsFChhO0orl4aCItJwMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/privacy.vue")
  },
  {
    name: "rooms-id",
    path: "/rooms/:id()",
    meta: _91id_936XsMaq8s7PacOtANeby6ik_45zbIsfy7KE4lijZDqptM4Meta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/rooms/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    meta: _91id_93_45_NfpBHtAb4hS6_f6EF5PyfaenzC_45j1g90M_45Xh8r_XQMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/products/[id].vue")
  },
  {
    name: "sellers-apply",
    path: "/sellers/apply",
    meta: apply_45tD6Gx_45XsZAqH1IHVzrSb5TllbNrB_rt7yQQy6_XLPkMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/sellers/apply.vue")
  },
  {
    name: "sellers",
    path: "/sellers",
    meta: indexhX0lGB6epoKyqyUeTI0Rw6_gn8QH0RrKwXHU_hbHJUsMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/sellers/index.vue")
  },
  {
    name: "acceptable-use",
    path: "/acceptable-use",
    meta: acceptable_45useE9L8hotiqtbSoEEQn515k2qyhHzJ8tmH_45_BcHGqmg1MMeta || {},
    component: () => import("/builds/teamtilt/web/tilt-web/pages/acceptable-use.vue")
  }
]